<div class="container py-4 py-md-8">
  <div class="d-flex align-items-center flex-column py-8">
    <h3 class="text-center">{{ 'FOOTER.TEXT_LINE1' | translate }}</h3>

    <p class="mb-4 text-center">{{ 'FOOTER.TEXT_LINE2' | translate }}</p>

    <div class="mb-3 text-center">
      <a *ngFor="let link of content?.links" class="px-2 py-1 text-muted" [href]="link.url" target="_blank">{{ link.title }}</a>
    </div>

    <div class="d-flex align-items-center">
      <img
        *ngIf="content?.companyLogo"
        class="m-2 footer-img"
        [src]="content.companyLogo.url"
        [title]="content.companyLogo.title"
        [alt]="content.companyLogo.title"
      />
      <img
        *ngIf="content?.sgrLogo"
        class="m-2 footer-img"
        [src]="content.sgrLogo.url"
        [title]="content.sgrLogo.title"
        [alt]="content.sgrLogo.title"
      />
      <img
        *ngIf="content?.anvrLogo"
        class="m-2 footer-img"
        [src]="content.anvrLogo.url"
        [title]="content.anvrLogo.title"
        [alt]="content.anvrLogo.title"
      />
      <img
        *ngIf="content?.iataLogo"
        class="m-2 footer-img"
        [src]="content.iataLogo.url"
        [title]="content.iataLogo.title"
        [alt]="content.iataLogo.title"
      />
    </div>
  </div>
</div>
